<template>
  <div v-if="data.label&&data.label.length>0 || data.title&&data.title.length>0">
    <span v-bind:id="this.data.id"></span>
    <h2 v-if="this.data.level=='1'" class="jom-secTitle theme-background">
      <component :is="'jo' + item.name" v-for="item in this.data.label" v-bind:key="item.index" v-bind:data="item.data">
      </component>{{data.label && data.label.length > 0 ? ' ' : ''}}<component :is="'jo' + item.name" v-for="item in this.data.title" v-bind:key="item.index" v-bind:data="item.data"></component>
    </h2>
    <h3 v-else-if="this.data.level=='2'" class="secTitle">
      <component :is="'jo' + item.name" v-for="item in this.data.label" v-bind:key="item.index" v-bind:data="item.data">
      </component>{{data.label && data.label.length > 0 ? ' ' : ''}}<component :is="'jo' + item.name" v-for="item in this.data.title" v-bind:key="item.index" v-bind:data="item.data"></component>
    </h3>
    <p class="jo-secTitle3" v-else>
      <component :is="'jo' + item.name" v-for="item in this.data.label" v-bind:key="item.index" v-bind:data="item.data">
      </component>{{data.label && data.label.length > 0 ? ' ' : ''}}<component :is="'jo' + item.name" v-for="item in this.data.title" v-bind:key="item.index" v-bind:data="item.data"></component>
    </p>
  </div>
</template>

<script>
  import joinlineformula from '../formula/inlineformula.vue'
  import joinlinegraphic from '../fig/inlinegraphic.vue'
  export default {
    components: {
      joinlineformula,
      joinlinegraphic
    },
    props: [
      'data'
    ],
  }
</script>

<style lang="scss" scoped>

  h2.jom-secTitle{
    sup{
      color: #fff;
    }
  }
  h3{
    /*margin: 1rem 2rem;*/
  }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/common/sectitle.vue